<template>
  <div class="right_box_main">
    <!-- 面包屑导航 -->
   
    <div class="card-box">
      <!-- 右边卡片 -->
      <div class="card-rb">
        <div class="card-4">
          <el-card :body-style="{ padding: '16px' }">
            <div class="fisthang">
              <el-form :inline="true" :model="searchlist" class="demo-form-inline" size="mini">
                <el-form-item label="姓名：" style="margin:0 10 0 0;">
                  <el-input v-model="searchlist.personName" placeholder="请输入姓名" style="width:150px"></el-input>
                </el-form-item>
                <el-form-item label="所属部门：" prop="deptId">
                  <el-select
                    :disabled="editDisable"
                    v-model="searchlist.deptId"
                    placeholder="--请选择--"
                    style="width:150px"
                    @change="changeBmType"
                  >
                    <el-option
                      v-for="item in bmTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="类型：" style="margin:0 30 0 0;">
                  <el-select
                    :disabled="editDisable"
                    v-model="addform.proofOfEstablishmentTypeId"
                    placeholder="--请选择--"
                    style="width:150px"
                  >
                    <el-option
                      v-for="item in smallTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchlistdata">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="info" @click="searchlistReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="three">
              <el-button
                type="primary"
                size="mini"
                @click="showDialogForm('','add')"
              >新增</el-button>
            </div>
            <!-- 表格盒子 -->
            <div class="table_card">
              <el-table
                :data="tableData"
                :header-cell-style="{ background: '#f8fafa' }"
                border
                align="center"
              >
                <!-- <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                border align="center" @row-click="changeColor" :row-style="selectedHighlight" >-->
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
                <el-table-column align="center" prop="deptName" label="所属部门"></el-table-column>
                <el-table-column align="center" prop="proofOfEstablishmentTypeId" label="类型" :formatter="formatter"></el-table-column>
                <el-table-column align="center" prop="personName" label="姓名"></el-table-column>
                <el-table-column align="center" prop="personPhone" label="联系电话"></el-table-column>
                <el-table-column align="center" prop="personIdno" label="身份证号"></el-table-column>
                <el-table-column align="center" prop="personAddress" label="居住地址"></el-table-column>
                <!-- <el-table-column align="center" prop="releaseDate" label="发布时间"></el-table-column> -->
                <el-table-column align="center" label="操作" width="300" fixed="right">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                      <button
                        class="iconfont icon-chakan tabBtn"
                        @click="showDialogForm(scope.row.id,'detail')"
                      ></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="编辑" placement="top-start">
                      <button
                        class="iconfont icon-bianji3 tabBtn"
                        @click="showDialogForm(scope.row.id,'edit')"
                      ></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="打印" placement="top-start">
                      <button class="iconfont icon-dayin tabBtn" @click="showDyForm(scope.row.id)"></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                      <button
                        class="iconfont icon-icon7 tabBtn"
                        @click="showdeletepanduan(scope.row.id)"
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :page-size="pageConfig.pageSize"
                layout="total, prev, pager, next, jumper"
                @current-change="handleCurrentChange"
                :total="pageConfig.total"
              ></el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showadd"
      width="1100px"
      :before-close="clearadddata"
    >
      <el-form ref="addform" :rules="rules" :model="addform" label-width="110px" size="mini">
        <el-form-item label="所属部门:" prop="deptId">
          <el-select
            :disabled="editDisable"
            v-model="addform.deptId"
            placeholder="--请选择--"
            style="width:50%"
            @change="changeBmType"
          >
            <el-option
              v-for="item in bmTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型:" prop="proofOfEstablishmentTypeId">
          <el-select
            :disabled="editDisable"
            v-model="addform.proofOfEstablishmentTypeId"
            placeholder="--请选择--"
            style="width:50%"
          >
            <el-option
              v-for="item in smallTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名：" prop="personName">
          <el-input
            :disabled="editDisable"
            v-model="addform.personName"
            placeholder="请输入姓名"
            style="width: 50%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="personPhone">
          <el-input
            :disabled="editDisable"
            v-model="addform.personPhone"
            placeholder="请输入联系电话"
            style="width: 50%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="personIdno">
          <el-input
            :disabled="editDisable"
            v-model="addform.personIdno"
            placeholder="请输入身份证号"
            style="width: 50%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="居住地址：" prop="personAddress">
          <el-input
            :disabled="editDisable"
            v-model="addform.personAddress"
            placeholder="请输入姓名"
            style="width: 50%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容：" prop="content">
          <el-input
            type="textarea"
            :disabled="editDisable"
            v-model="addform.content"
            placeholder="请输入姓名"
            style="width: 50%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传附件：">
          <el-upload
            :disabled="editDisable"
            :limit="3"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :on-success="uploadSuccess"
            :action="uploadUrl"
            :on-remove="handleRemove"
            :on-preview="handlePreview"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <span slot="tip" class="el-upload__tip">&nbsp;&nbsp;&nbsp;附件大小不超过2M</span>
          </el-upload>
        </el-form-item>
        <el-form-item label="上传图片：">
          <uploadImgs
            @offFalse="up_off = false"
            :disabled="editDisable"
            :off="up_off"
            v-model="addform.imagePath"
          ></uploadImgs>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button
          v-if="showSaveBtn"
          type="primary"
          size="small"
          style="margin: 0 30px"
          @click="saveadddata('addform')"
        >保存</el-button>
        <el-button type="info" size="small" @click="clearadddata">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 弹出框打印签到表 -->
    <el-dialog title="打印签到表" :visible.sync="print" width="1100px">
      <section class="dayincss" ref="print">
        <div class="zm-tit" v-if="printlist.proofOfEstablishmentTypeId == 1">低保证明</div>
        <div class="zm-tit" v-else-if="printlist.proofOfEstablishmentTypeId == 2">残疾人证明</div>
        <div class="zm-tit" v-if="printlist.proofOfEstablishmentTypeId == 3">家庭生活困难证明</div>
        <div class="zm-tit" v-if="printlist.proofOfEstablishmentTypeId == 4">个人生育情况证明</div>
        <div class="zm-tit" v-else>户籍证明</div>
        <div class="con"><p>姓名：{{printlist.personName}}</p></div>
        <div class="con"><p>身份证号：{{printlist.personIdno}}</p></div>
        <div class="con"><p>居住地址：{{printlist.personAddress}}</p></div>
        <div class="con"><p>{{printlist.content}}</p></div>
      </section>

      <div class="boontbtn">
        <el-button type="primary" size="small" style="margin: 0 30px" @click="dy">打印</el-button>
        <el-button type="info" size="small" @click="print=false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "../../../utils/request.js";
import { getZmkjList } from "@/api/api";
import uploadImgs from "@/components/uploadImgs/index.vue";
import { post } from "@/api/requrestHttp.js";
export default {
  components: { uploadImgs },
  data() {
    return {
      print: false,
      printlist: {},
      printName: "",
      up_off: true,
      smallTypes: [],
      bmTypes: [],
      time: new Date(),
      dialogTitle: "新增",
      // 新增弹出层
      flag: "add",
      showadd: false,
      editDisable: false,
      showSaveBtn: true,
      addform: {},
      fileList: [],
      rules: {
        deptId: [{ required: true, message: "请选所属部门", trigger: "blur" }],
        proofOfEstablishmentTypeId: [
          { required: true, message: "请选类型", trigger: "blur" }
        ],
        personName: [
          { required: true, message: "请输入姓名", trigger: "blur" }
        ],
        personPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        personIdno: [
          { required: true, message: "请输入身份证号", trigger: "blur" }
        ],
        personAddress: [
          { required: true, message: "请输入居住地址", trigger: "blur" }
        ],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }]
      },
      Types: [],
      uploadUrl: request.defaults.baseURL + "/oneStopUpload/info/uplodfiles",
      // 查询
      searchlist: {},
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      }
    };
  },
  methods: {
    formatter(row, column){
      switch (row.proofOfEstablishmentTypeId) {
        case 1:
          return "低保证明";
          break;
        case 2:
          return "残疾人证明";
          break;
        case 3:
          return "家庭生活困难证明";
          break;
        case 5:
          return "户籍证明";
          break;
        case 4:
          return "个人生育情况证明";
          break;
      }
    },
    dy() {
      this.$print(this.$refs.print);
    },
    //所属部门change
    changeBmType(e) {
      if (e == 59) {
        this.smallTypes = [
          { label: "低保证明", value: "1" },
          { label: "残疾人证明", value: "2" },
          { label: "家庭生活困难证明", value: "3" },
          { label: "户籍证明", value: "5" }
        ];
      } else {
        this.smallTypes = [{ label: "个人生育情况证明", value: "4" }];
      }
    },
    //获取所属部门
    getZmkjInform() {
      getZmkjList({ orgType: 2 }).then(res => {
        this.bmTypes = res.content;
      });
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    searchlistReset() {
      this.searchlist = {};
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    //获取列表数据
    async getPageDatas() {
      var res = await request({
        url: "/proofOfEstablishment/info/listProofOfEstablishment",
        method: "POST",
        data: {
          ...this.pageConfig,
          ...this.searchlist
        }
      });
      if (res.code == 200) {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list;
      } else {
        //console.log(res);
        this.$message({
          message: "数据加载异常：",
          type: "error"
        });
      }
    },
    showDyForm(id) {
      this.print = true;
      post("/proofOfEstablishment/info/getProofOfEstablishment", {
        id: id
      })
        .then(res => {
          this.printlist = res.content;
         // console.log("www",res.content)
        })
        .catch(errer => {
          this.$message.error("获取信息失败");
        });
    },

    async showDialogForm(id, flag) {
      this.flag = flag;
      if (id != "") {
        if (flag == "edit") {
          this.editDisable = false;
          this.showSaveBtn = true;
          this.dialogTitle = "编辑";
        } else if (flag == "audit") {
          this.editDisable = true;
          this.showSaveBtn = true;
          this.dialogTitle = "审批";
        } else if (flag == "detail") {
          this.editDisable = true;
          this.showSaveBtn = false;
          this.dialogTitle = "查看";
        }
        //获取编辑项的最新数据
        var res = await request({
          url: "/proofOfEstablishment/info/getProofOfEstablishment",
          method: "POST",
          data: { id: id }
        });
        // console.log(res)
        if (res.code == 200) {
          this.addform = res.content;
          this.addform.deptId = res.content.deptId + "";
          this.addform.proofOfEstablishmentTypeId =
            res.content.proofOfEstablishmentTypeId + "";
          this.showadd = true;
          //上传数组显示
          this.fileList = [];
          var temp = {};
          if (
            res.content.enclosurePath != null &&
            res.content.enclosurePath != ""
          ) {
            var namesArr = [];
            if (
              res.content.enclosureName != null &&
              res.content.enclosureName != ""
            ) {
              namesArr = res.content.enclosureName;
            }
            var enclosureArr = res.content.enclosurePath;

            temp = {
              name: namesArr,
              url: enclosureArr
            };
            this.fileList.push(temp);
          }
        } else {
          //console.log(res.code + "：" + res.message);
          this.$message({
            message: "数据项加载异常",
            type: "error"
          });
          this.showadd = false;
        }
      } else {
        this.editDisable = false;
        this.showSaveBtn = true;
        this.showadd = true;
        this.dialogTitle = "新增";
        this.fileList = [];
      }
    },
    //上传
    handleExceed(files, fileList) {
      var selected = files.length;
      var totalselected = selected + fileList.length;
      this.$message.warning(
        "当前限制选择3个文件，本次选择了" +
          selected +
          "个文件，共选择了" +
          totalselected +
          "个文件"
      );
    },
    //确保每次只能上传一个文件，可多次上传
    uploadSuccess(response, file, fileList) {
      //console.log(response);
      if (response.code == 200) {
        this.fileList.push({
          name: response.content.name,
          url: response.content.path
        });
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //附件预览
    handlePreview(file) {
      window.open(file.url);
    },
    //获取新增所有数据发请求
    async saveadddata(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.fileList.length > 0) {
            this.addform.enclosurePath = [];
            this.addform.enclosureName = [];
            this.fileList.forEach(item => {
              //   this.addform.enclosurePath = this.addform.enclosurePath + ',' + item.url
              //   this.addform.enclosureName = this.addform.enclosureName + ',' + item.name
              this.addform.enclosurePath = item.url;
              this.addform.enclosureName = item.name;
            });
          }

          let url = "/proofOfEstablishment/info/updateProofOfEstablishment";
          if (this.flag == "add") {
            url = "/proofOfEstablishment/info/insertProofOfEstablishment";
          }
          request({
            url: url,
            method: "POST",
            data: {
              ...this.addform
            }
          })
            .then(res => {
              this.$message({
                message: this.dialogTitle + "成功",
                type: "success"
              });
              this.showadd = false;
              this.pageConfig.pageNo = 1;
              this.getPageDatas();
            })
            .catch(error => {
              this.$message({
                message: this.dialogTitle + "失败：" + res.message,
                type: "error"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 新增弹出框重置
    clearadddata() {
      this.showadd = false;
      this.addform = {};
    },
    //删除操作
    async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var res = await request({
            url: "/proofOfEstablishment/info/deleteProofOfEstablishment",
            method: "POST",
            data: { id: id }
          });
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.showadd = false;
            this.pageConfig.pageNo = 1;
            this.getPageDatas();
          } else {
            //console.log(res);
            this.$message({
              message: "删除失败：" + res.message,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },
  mounted() {
    // 初始化数据
    this.Types = [
      { label: "公共事务", value: "公共事务" },
      { label: "其它", value: "其它" }
    ];
    this.getPageDatas();
    this.getZmkjInform();
  }
};
</script>

<style lang="less" scoped>
.con{
  width: 60%;
  margin: 20px auto;
}
.zm-tit{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
      font-size: 22px;
    }
    .tabBtn:nth-child(2) {
      color: #ff04ed;
      // font-size: 25px;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
      // font-size: 25px;
    }
    .tabBtn:nth-child(5) {
      color: #e400ff;
      font-size: 22px;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
      // font-size: 25px;
    }
    .active_Btn {
      color: #ff04ed !important;
      // font-size: 25px;
    }
  }
}
</style>